module.exports = __webpack_public_path__ + "static/avenirltstd-light-0b78ec9d509f67bfe3f8458c9d285df0.otf";